
export default {
  name: 'LayoutNotFound',
}
